<template>
    <article v-if="item" class="post-item" :class="['type-' + item.post_type]">
        <router-link
            :to="link"
            v-if="item.post_type === 'page'"
            :id="`${item.title}-page`"
        >
            <h2 v-html="title"></h2>
        </router-link>
        <router-link :to="link" :id="`${title}-page`" v-else>
            <figure class="image" v-if="img">
                <img :src="img" />
            </figure>
            <h3 class="type" v-if="type" v-html="type"></h3>
            <h2 class="post-title" v-if="title" v-html="title"></h2>
        </router-link>
    </article>
</template>

<script>
export default {
    props: {
        item: {
            type: Object,
            default: false
        }
    },

    data() {
        return {
            type: "",
            img: "",
            title: "",
            link: "",
            id: ""
        };
    },

    mounted() {
        if (this.item.title && this.item.title.rendered) {
            this.title = this.item.title.rendered;
        } else {
            this.title = this.item.post_title;
        }

        this.link = this.item.link.replace(
            window.globals.home_url,
            this.$base_url
        );

        if (
            (this.item.post_type === "case" ||
                this.item.post_type === "viewpoint") &&
            this.item.thumbnail
        ) {
            this.img = this.item.thumbnail.sizes.medium_large;
        } else if (this.item.featured_image) {
            this.img = this.item.featured_image.medium_large;
        }

        switch (this.item.post_type) {
            case "viewpoint":
                this.type = "Viewpoint";
                break;

            case "case":
                this.type = "Case Study";
                break;
        }

        // if (this.item.type === 'press') {
        //     this.date_str = format(new Date(this.item.date), 'DD MMM YYYY');
        // } else {
        //     this.date_str = GetDateTime(this.item);
        // }
    }
};
</script>

<style lang="scss" scoped>
.post-item {
    width: 33.33%;
    padding: var(--padding-50);
    box-sizing: border-box;

    &:hover {
        h2 {
            text-decoration: underline;
        }

        .image img {
            transform: scale(0.95);
        }
    }

    a {
        position: relative;
        background: var(--white);
        box-sizing: border-box;
        overflow: hidden;
    }

    .image {
        width: 100%;
        display: block;
        margin: 0 0 calc(var(--padding-25) + 0.3rem);
        position: relative;

        &::before {
            content: "";
            display: block;
            padding-bottom: 130%;
        }

        img {
            width: 100%;
            height: 100%;
            position: absolute;
            left: 0;
            top: 0;
            display: block;
            object-fit: cover;
            transition: all 0.2s ease-out;
        }
    }

    .type {
        font-size: var(--tiny-size);
        letter-spacing: 0.02rem;
        text-align: center;
        text-transform: uppercase;
    }

    .post-title {
        margin: var(--padding-25) 0;
        text-align: center;
    }

    &.type-page {
        a {
            display: block;
            background: var(--black);
            position: relative;

            &:hover {
                background: var(--white) !important;

                h2 {
                    color: var(--black);
                    text-decoration: none;
                }
            }

            &::before {
                content: "";
                display: block;
                padding-bottom: 130%;
            }

            h2 {
                padding: var(--padding-25);
                margin: 0;
                text-align: center;
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                color: var(--white);
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                font-size: var(--title-size);
                font-weight: bold;
                text-decoration: none;
                line-height: 1;
            }

            &:hover {
                background: var(--grey);
                text-decoration: none;
            }
        }
    }
}

@media only screen and (max-width: 767px) {
    .post-item {
        .post-title {
            font-size: var(--base-size);
        }
        .image {
            margin: 0 0 var(--padding-50);
        }
    }
}
</style>
